import { building, dev } from '$app/environment'
import {
  PUBLIC_APP_VERSION,
  PUBLIC_SENTRY_CLIENT_DSN,
  PUBLIC_SENTRY_ENVIRONMENT,
} from '$env/static/public'
import {
  browserTracingIntegration,
  handleErrorWithSentry,
  init,
  replayIntegration,
  setUser,
} from '@sentry/sveltekit'
import { themeMode } from './lib/runes/theme-mode.svelte'
import { authStore } from './store/auth'

if (!building) {
  init({
    enabled: !dev,
    dsn: PUBLIC_SENTRY_CLIENT_DSN,
    release: PUBLIC_APP_VERSION,
    integrations: [browserTracingIntegration(), replayIntegration()],
    environment: PUBLIC_SENTRY_ENVIRONMENT,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })

  themeMode.init()

  // Initialize the auth store
  authStore.init()
  authStore.authenticatedUser.subscribe(u => {
    if (!u) setUser(null)
    else
      setUser({
        id: u.uid,
        email: u.email ?? '',
        username: u.phoneNumber ?? '',
      })
  })
}

export const handleError = handleErrorWithSentry()
